module["exports"] = [
  "?#? #?#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_CA/address/postcode.js
// module id = 756
// module chunks = 0